{
  "fr": {
    "mainFobizzNavbar": {
      "a11y": {
        "actions": "Actions",
        "closeNavigation": "Fermer la navigation",
        "mainNav": "Menu",
        "openNavigation": "Ouvrir la navigation",
        "skipToContent": "Aller au contenu",
        "closeFlyout": "Fermer le flyout"
      },
      "login": "Se connecter",
      "logoHint": "Retour à la page d'accueil",
      "myfobizz": {
        "headers": {
          "adminArea": "Espace admin 🤓",
          "myfobizz": "Mon fobizz"
        },
        "links": {
          "backofficePlatform": "Backoffice",
          "contact": "Aide et contact",
          "folders": "Mon espace de stockage",
          "histories": "Mon historique",
          "news": "Nouveautés",
          "partnersOverview": "Vue d'ensemble des partenaires",
          "profile": "Mon profil",
          "features": "Feature Flags",
          "reviewerSection": "Section des réviseurs",
          "subscriptions": "Mes licences",
          "timetable": "Emploi du temps",
          "toTeach": "Accéder à to teach"
        }
      },
      "navbarSearch": {
        "placeholder": "Accès rapide",
        "results": {
          "courses": "Formations",
          "empty": "Aucun résultat",
          "materials": "Matériel pédagogique",
          "myContent": "Mon espace de stockage",
          "schoolClassesAndProjects": "Salles de classe et projets",
          "showAll": "Tout afficher",
          "showAllSchoolClasses": "Accéder aux salles de classe",
          "showAllTools": "Accéder aux outils",
          "showAllWithCount": "Tout afficher ({count})",
          "tools": "Outils"
        }
      },
      "breadcrumb": {
        "tools": "Outils"
      },
      "pupilLogin": {
        "text": "Accédez aux outils IA et au matériel pédagogique. Vous recevrez l'accès individuel de votre enseignant·e.",
        "title": "Se connecter en tant qu'élève"
      },
      "signup": {
        "text": "Créez un compte gratuit et accédez à certaines formations, outils et matériel pédagogique.",
        "title": "S'inscrire"
      },
      "teacherLogin": {
        "text": "Créez et gérez du matériel pédagogique pour votre classe et activez l'IA pour vos projets.",
        "title": "Se connecter en tant qu'enseignant·e"
      },
      "tooltips": {
        "homepage": "Page d'accueil",
        "myfobizz": "Mon fobizz",
        "search": "Accès rapide à toutes les formations et au matériel pédagogique"
      },
      "coachmarkTour": {
        "title": "Nouvelle navigation",
        "next": "Continuer",
        "done": "Terminé",
        "steps": {
          "step1": "Avec la nouvelle navigation, vous accédez encore plus rapidement aux zones et fonctions principales.",
          "step2": "Sous Organiser, vous trouverez votre espace de stockage, vos salles de classe et vos emplois du temps en un seul endroit.",
          "step3": "Grâce à votre avatar, vous gardez un œil sur votre statut de licence et accédez à d'autres informations importantes."
        }
      },
      "sharedLibraryHint": {
        "title": "Nouveau : Espace partagé",
        "headline": "Partager du matériel",
        "body": "Déposez des contenus dans le stockage partagé afin que vous puissiez les utiliser dans l'équipe pédagogique. Comme une armoire à matériel numérique.",
        "confirm": "OK"
      },
      "licenseInfo": {
        "summary": "{type} : {areas}",
        "types": {
          "einzel": "Licence individuelle",
          "schul": "Licence scolaire"
        },
        "areas": {
          "courses": "Formations",
          "tools": "Outils",
          "toTeach": "to teach"
        },
        "limited": "Utilisation limitée (Mise à niveau)"
      },
      "offcanvas": {
        "headers": {
          "organize": "Organiser",
          "mySchool": "Mon école",
          "settings": "Mes paramètres",
          "partners": "Partenaires"
        },
        "links": {
          "sharedLibrary": "Dépôt partagé",
          "classes": "Mes salles de classe",
          "schoolOverview": "Vue d'ensemble",
          "licenseManagement": "Gestion des licences",
          "internalWorkshops": "Ateliers internes",
          "authorArea": "Espace auteurs"
        }
      },
      "tabs": {
        "start": "Accueil",
        "organize": "Organiser",
        "tools": "Outils",
        "material": "Matériel",
        "partner": "Partenaires",
        "courses": "Formations"
      },
      "flyout": {
        "organize": {
          "folders": {
            "headline": "Mon espace de stockage",
            "description": "Vos matériels au même endroit",
            "linkLabel": "Vers la sauvegarde"
          },
          "sharedLibrary": {
            "headline": "Dépôt partagé",
            "description": "Partager du matériel avec ton groupe scolaire",
            "linkLabel": "Vers la sauvegarde"
          },
          "classes": {
            "headline": "Mes salles de classe",
            "description": "Créer des classes et travailler avec les élèves",
            "linkLabel": "Créer une salle de classe",
            "linkLabelPopulated": "Tout afficher"
          },
          "timetable": {
            "headline": "Emploi du temps",
            "description": "Planifier les cours et associer du matériel",
            "linkLabel": "Créer un emploi du temps",
            "linkLabelPopulated": "Afficher",
            "todayTime": "aujourd'hui, {time}"
          }
        },
        "material": {
          "partner": {
            "headline": "fobizz & Partenaires",
            "description": "Matériels de fobizz et de ses partenaires",
            "linkLabel": "Découvrir le matériel"
          },
          "toTeach": {
            "headline": "Contenus",
            "description": "Matériels de to teach",
            "linkLabel": "Découvrir le matériel"
          },
          "community": {
            "headline": "Communauté fobizz",
            "description": "Matériels de la communauté fobizz",
            "linkLabel": "Découvrir le matériel"
          },
          "bookmarks": {
            "headline": "Liste de favoris",
            "description": "Matériels enregistrés",
            "linkLabel": "Voir la liste de favoris"
          }
        },
        "tools": {
          "aiChat": {
            "headline": "Chat IA et assistants",
            "items": {
              "chat": "Chat IA",
              "assistants": "Catalogue d'assistants IA",
              "miniTool": "Laboratoire de prompts"
            }
          },
          "multimedia": {
            "headline": "Outils multimédia IA",
            "items": {
              "image": "Générer une image",
              "podcast": "Podcast",
              "transcript": "Transcription"
            }
          },
          "material": {
            "headline": "Créer du matériel",
            "items": {
              "worksheet": "Fiche de travail",
              "classroomScreen": "Tableau numérique",
              "survey": "Sondage"
            }
          },
          "share": {
            "headline": "Partager du contenu",
            "items": {
              "fileSharing": "Partager des fichiers",
              "qrCode": "Code QR",
              "linkShortener": "Raccourcir un lien"
            }
          },
          "showAll": "Tout afficher",
          "showAllTools": "Afficher tous les outils"
        },
        "start": {
          "stats": {
            "fortbildungen": "Formation | Formations",
            "materialien": "Matériel pédagogique | Matériel pédagogique",
            "klassen": "Classe | Classes",
            "prompts": "Prompt | Prompts"
          }
        },
        "courses": {
          "catalog": {
            "headline": "Catalogue de cours",
            "liveWebinare": "Webinaires en direct",
            "fortbildungen": "Formations",
            "linkLabel": "Vers le catalogue de cours"
          },
          "myCourses": {
            "headline": "Mes formations",
            "descriptionEmpty": "Vous n'avez pas de formations et de qualifications supplémentaires actives",
            "activeCount": "Formations actives ({count})",
            "bookmarkedCount": "Formations enregistrées ({count})",
            "linkLabel": "Mes formations",
            "linkLabelEmpty": "Découvrir des formations"
          },
          "additionalQualifications": {
            "headline": "Qualifications supplémentaires",
            "description": "Inscrivez-vous maintenant pour les nouveaux ZQ de l'année scolaire 2026/2027",
            "linkLabel": "Vers la page d'information"
          },
          "aiLiteracyTraining": {
            "headline": "AI Literacy Training",
            "description": "Participez à notre formation en ligne gratuite sur la culture de l'IA pour les enseignants.",
            "linkLabel": "En savoir plus et s'inscrire"
          }
        }
      },
      "mobileNav": {
        "tools": {
          "showAll": "Tout afficher"
        }
      },
      "startPage": {
        "greeting": "Bonjour {user} !",
        "greetingFallback": "Bonjour !",
        "subtitle": "Bienvenue chez fobizz.",
        "welcomeBack": "Bon retour.",
        "news": {
          "headline": "Nouveautés",
          "linkLabel": "Voir toutes les nouveautés"
        },
        "toTeach": {
          "label": "Matériel pédagogique | Matériel pédagogique",
          "linkLabel": "to teach : {count} matériel pédagogique, ouvrir dans un nouvel onglet | to teach : {count} matériel pédagogique, ouvrir dans un nouvel onglet"
        }
      }
    }
  }
}
